var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCyrylaPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cyryla"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "87.23 73.22 108.16 64.03 115.56 65.05 133.68 57.91 170.56 64.29",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "127.43 35.19 137.89 28.81 151.8 33.79",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "159.07 49.74 134.83 44 120.79 51.53 108.16 64.03",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "132.79 24.47 130.62 22.43 134.95 19.37 141.97 18.6 147.84 20.77 149.12 23.96 146.44 24.86",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "136.36 11.46 135.21 9.03 137 7.63 141.34 7.37 144.91 8.14 145.42 11.33 144.65 11.33",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "151.93 80.11 159.84 75.39 166.73 80.24",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "89.27 71.69 106.63 55.61 129.34 41.19",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "157.8 48.85 149.76 41.7 137.51 38.77 128.83 44",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "156.78 50.12 156.78 55.1 169.15 63.52",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "111.86 61.23 116.45 61.99 121.05 56.76 135.59 50.89 156.78 55.1",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.85,
    y1: 43.23,
    x2: 129.85,
    y2: 35.32,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.76,
    y1: 41.7,
    x2: 149.76,
    y2: 33.79,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.51,
    y1: 38.77,
    x2: 137.51,
    y2: 29.96,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.59,
    y1: 50.89,
    x2: 135.59,
    y2: 45.02,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.56,
    y1: 56.12,
    x2: 121.56,
    y2: 51.4,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.3,
    y1: 30.47,
    x2: 133.3,
    y2: 21.79,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.93,
    y1: 31.37,
    x2: 145.93,
    y2: 20.77,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.15,20.26c-.34-4.07,1.49-6.93,4.85-8.93v-2.68",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.02,9.03v2.3c2.29,2.08,3.25,4.92,3.06,8.42",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "136.49 6.86 140.19 .99 144.4 7.12",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,11.33c2.13-.74,4.5-.62,7.02,0",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "159.46 74.75 151.03 74.75 143.63 79.99 152.31 79.99",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.71,
    y1: 79.22,
    x2: 153.33,
    y2: 79.22,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "134.19 58.42 134.19 105.12 116.83 103.98 108.28 104.36 87.23 102.19 87.23 73.48",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.81,
    y1: 103.98,
    x2: 115.81,
    y2: 65.57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.79,
    y1: 64.67,
    x2: 108.79,
    y2: 104.36,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "134.19 105.12 168.01 103.98 168.01 64.03",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.58,
    y1: 65.95,
    x2: 104.58,
    y2: 103.72,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.99,
    y1: 70.67,
    x2: 93.99,
    y2: 101.93,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.97,
    y1: 68.76,
    x2: 98.97,
    y2: 102.57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "147.08 104.49 147.08 82.15 158.05 82.41 158.05 103.85",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.05,
    y1: 104.36,
    x2: 152.05,
    y2: 82.41,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.74 73.48 148.74 63.14 154.1 63.78 154.1 73.73 148.74 73.48",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.56 71.56 100.24 72.84 100.24 82.54 103.31 82.03 103.56 71.56",
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.99,74.63l-2.68,1.15v8.42l2.94-.77s-.64-9.19-.26-8.81Z",
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "87.23 102.19 85.44 102.19 85.44 104.74 108.03 108.06 117.34 107.42 134.32 108.83 170.05 107.42",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyrylaPop);
export default __webpack_public_path__ + "static/media/cyryla_pop.d614cd48e441a7e4282b8890ae8ba514.svg";
export { ForwardRef as ReactComponent };